import { GDPRCookie, GDPR_PREFERENCES_COOKIE } from '@wkda/gdprlib';
import * as helpers from './helpers';
import * as constants from './constants';

function getExpirationDate() {
  const expirateionDate = new Date();
  expirateionDate.setFullYear(expirateionDate.getFullYear() + 2);

  return expirateionDate;
}

/**
 * @param {Object} args
 * @param {import("./useGDPRBannerContext").APIService} args.APIService
 * @param {import("./useGDPRBannerContext").CookieService} args.cookieService
 * @param {boolean} args.isProd
 * @param {() => void} [args.onSubmit]
 */
export function createSubmitHandlers({
  APIService,
  isProd,
  cookieService,
  onSubmit,
}) {
  async function removeStorageKeys() {
    const gdprCookieService = await GDPRCookie.init(
      cookieService.getAll(),
      cookieService,
      isProd,
      APIService,
    );

    try {
      Object.keys(localStorage).forEach((key) => {
        if (!gdprCookieService.isPermitted(key)) {
          localStorage.removeItem(key);
        }
      });
    } catch (e) {
      console.error('LocalStorage unavailable');
    }
  }

  function getSelectedCategories(categories) {
    return Object.keys(categories).reduce((acc, key) => {
      return !categories[key] ? acc : [...acc, key];
    }, []);
  }

  /**
   * @param {{[key: string]: boolean}} categoriesSelectionMap
   */
  async function submitAll(categoriesSelectionMap) {
    await APIService.post('/v1/gdpr-preferences/', {
      categories: getSelectedCategories(categoriesSelectionMap),
      currentUrl: window.location.href,
    });
  }

  /**
   * @param {{[key: string]: boolean}} categoriesSelectionMap
   */
  function setCookies(categoriesSelectionMap) {
    const categories = getSelectedCategories(categoriesSelectionMap);
    const categoriesToSet =
      categories.length === 1 &&
      categories[0] === constants.categories.ESSENTIAL
        ? []
        : categories;

    cookieService.set(
      GDPR_PREFERENCES_COOKIE,
      {
        categories: categoriesToSet,
      },
      { expires: getExpirationDate(), path: '/', sameSite: 'lax' },
    );
  }

  return {
    /**
     * @param {{[key: string]: boolean}} categoriesSelectionMap
     */
    async submit(categoriesSelectionMap) {
      setCookies(categoriesSelectionMap);

      if (helpers.isEverythingSelected(categoriesSelectionMap)) {
        await submitAll(categoriesSelectionMap);
      }
      try {
        await removeStorageKeys();
      } catch (error) {
        console.error('LocalStorage entries could not be cleared!');
      }

      if (typeof onSubmit === 'function') {
        onSubmit();
      }
    },
  };
}
